import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  country() {
    return 'DE';
  },

  domain() {
    return faker.lorem.sentence();
  },

  type() {
    const typeOptions = ['shop', 'website'];

    return faker.helpers.arrayElement(typeOptions);
  },

  recurringScan() {
    const recurringScanOptions = [true, false];

    return faker.helpers.arrayElement(recurringScanOptions);
  },

  scanInterval() {
    const scanIntervalOptions = ['weekly', 'monthly'];

    return faker.helpers.arrayElement(scanIntervalOptions);
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsModified() {
    return faker.date.past();
  },

  afterCreate(a11yScanner, server) {
    let scans = server.createList('a11y-scan', 3);

    a11yScanner.update({
      scans: scans,
      activeScan: scans[0],
    });
  },
});
